export const MODAL_TITLE_ERROR = "Error al enviar el ticket de soporte";
export const MODAL_BODY_ERROR =
  "Ocurrió un error al procesar tu solicitud. Por favor, inténtalo de nuevo más tarde.";
export const MODAL_TITLE_SUCCESS = "Ticket de soporte enviado.";
export const PARTIAL_MODAL_BODY_SUCCESS =
  "creado correctamente. Intentaremos solucionar tu problema lo antes posible.";

// Screen Names
export enum ScreenStepType {
  FormularioAltas = "Formulario de altas.",
  SeleccionRolesIntervinientes = "Selección de roles de intervinientes.",
  LecturaContratoElements = "Lectura del contrato de Elements.",
  FirmaContratoElements = "Firma del contrato de Elements.",
  FirmaContratoPlanAhorro = "Firma del contrato de plan de ahorro",
  FirmaContratoPlanAhorroConvenience = "Firma del contrato de plan de ahorro (Convenience)",
}
